import {Subscription} from 'rxjs/Subscription';

export class SubscriptionsContainer {
    private subs = [];
    set add(s: Subscription) {
      this.subs.push(s);
    }
    dispose() {
      this.subs.forEach(
        s => {
          if (s && !s.closed) {
            s.unsubscribe();
          }
        },
        error => console.log(' Error in Unsubscribing ', error)
      );
    }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/subscriptions-container.ts